"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var getChildrenMap = function (getChildId, reactChildren) {
    return _.reduce(reactChildren, function (agg, reactComp, index) {
        var _a;
        return _.assign(agg, (_a = {}, _a[getChildId(reactComp)] = { reactComp: reactComp, index: index }, _a));
    }, {});
};
var getPropFromMap = function (prop) { return function (map, compId, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return _.get(map, [compId, prop], defaultValue);
}; };
var getCompFromChildrenMap = getPropFromMap('reactComp');
var getIndexFromChildrenMap = getPropFromMap('index');
exports.MeshChildrenRenderer = function (_a) {
    var _b = _a.children, children = _b === void 0 ? [] : _b, meshChildren = _a.meshChildren, getChildId = _a.getChildId;
    var childrenById = getChildrenMap(getChildId, React.Children.toArray(children));
    var getMeshChildrenRecursively = function (structureChildren) {
        return _(structureChildren)
            .sortBy(function (child) { return getIndexFromChildrenMap(childrenById, child.id); })
            .map(function (_a) {
            var childId = _a.id, grandchildren = _a.children;
            return getCompFromChildrenMap(childrenById, childId, React.createElement('div', { id: childId, key: childId, 'data-mesh-internal': true }, getMeshChildrenRecursively(grandchildren)));
        })
            .value();
    };
    return getMeshChildrenRecursively(meshChildren);
};
//# sourceMappingURL=MeshChildrenRenderer.js.map